'use client';

import { useEffect, useRef } from 'react';

interface AdSlotProps {
  slot: string;
  width: number;
  height: number;
  format?: 'auto' | 'rectangle' | 'horizontal' | 'vertical';
  className?: string;
}

export default function AdSlot({ slot, width, height, format = 'auto', className = '' }: AdSlotProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const pubId = process.env.NEXT_PUBLIC_ADSENSE_PUB_ID;

  useEffect(() => {
    if (!pubId || !containerRef.current) return;

    try {
      ((window as any).adsbygoogle = (window as any).adsbygoogle || []).push({});
    } catch {}
  }, [pubId]);

  if (!pubId) {
    return null;
  }

  return (
    <div ref={containerRef} className={className}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block', maxWidth: width, width: '100%', minHeight: height }}
        data-ad-client={pubId}
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
}
